import * as $ from 'jquery';

export class TimelineCommon {
    static init() {
        $('.timeline-selectable').click(ev => {
            const tgt = $(ev.target).closest('[data-url]');
            if (tgt.length) {
                const url = tgt.eq(0).attr('data-url');
                if (url) {
                    window.open(url, '_blank');
                }
            }
        })
    }
}